@if (displayPaymentTerm()) {
    <div class="col padding-horizontal-24">
        <!-- Label -->
        <div class="row">
            <div class="col">
                @if (paymentTermRequired()) {
                    <strong mark-required>{{ 'Zahlungsbedingung' | translate }}</strong>
                } @else {
                    <strong>{{ 'Zahlungsbedingung' | translate }}</strong>
                }
            </div>
        </div>

        @if (canChangePaymentTerm()) {
            <div class="row align-items-center cursor-pointer mx-auto" (click)="openPaymentTermSelection()">
                @if (paymentTerm()) {
                    <div class="col-auto pl-0" [title]="paymentTerm()!.valueDisplayLong">
                        {{ paymentTerm()!.valueDisplay }}
                    </div>
                }

                <div class="col-auto p-0 d-flex align-items-center">
                    <!-- Trash Button -->
                    @if (paymentTerm()) {
                        <button
                            mat-icon-button
                            color="warn"
                            [matTooltip]="'Zahlungsbedingung entfernen' | translate"
                            (click)="deleteCurrent($event)"
                        >
                            <em class="fas fa-trash"></em>
                        </button>
                    }

                    <!-- Stift Button -->
                    <button class="text-primary" mat-icon-button>
                        <em class="fas fa-pen"></em>
                    </button>
                </div>
            </div>
        } @else {
            <div class="row align-items-center mx-auto">
                @if (paymentTerm()) {
                    <div class="col-auto pl-0" [title]="paymentTerm()!.valueDisplayLong">
                        {{ paymentTerm()!.valueDisplay }}
                    </div>
                }
            </div>
        }
    </div>
}
